'use strict';

const CONTRACT_COST_COUNT_LIMIT = 1024;
const SC_SPEC_DOC_LIMIT = 1024;
const SCSYMBOL_LIMIT = 32;
const MASK_ACCOUNT_FLAGS = 7;
const MASK_ACCOUNT_FLAGS_V17 = 15;
const MAX_SIGNERS = 20;
const MASK_TRUSTLINE_FLAGS = 1;
const MASK_TRUSTLINE_FLAGS_V13 = 3;
const MASK_TRUSTLINE_FLAGS_V17 = 7;
const MASK_OFFERENTRY_FLAGS = 1;
const MASK_CLAIMABLE_BALANCE_FLAGS = 1;
const MASK_LEDGER_HEADER_FLAGS = 7;
const AUTH_MSG_FLAG_FLOW_CONTROL_BYTES_REQUESTED = 200;
const TX_ADVERT_VECTOR_MAX_SIZE = 1e3;
const TX_DEMAND_VECTOR_MAX_SIZE = 1e3;
const MAX_OPS_PER_TX = 100;
const LIQUIDITY_POOL_FEE_V18 = 30;

exports.AUTH_MSG_FLAG_FLOW_CONTROL_BYTES_REQUESTED = AUTH_MSG_FLAG_FLOW_CONTROL_BYTES_REQUESTED;
exports.CONTRACT_COST_COUNT_LIMIT = CONTRACT_COST_COUNT_LIMIT;
exports.LIQUIDITY_POOL_FEE_V18 = LIQUIDITY_POOL_FEE_V18;
exports.MASK_ACCOUNT_FLAGS = MASK_ACCOUNT_FLAGS;
exports.MASK_ACCOUNT_FLAGS_V17 = MASK_ACCOUNT_FLAGS_V17;
exports.MASK_CLAIMABLE_BALANCE_FLAGS = MASK_CLAIMABLE_BALANCE_FLAGS;
exports.MASK_LEDGER_HEADER_FLAGS = MASK_LEDGER_HEADER_FLAGS;
exports.MASK_OFFERENTRY_FLAGS = MASK_OFFERENTRY_FLAGS;
exports.MASK_TRUSTLINE_FLAGS = MASK_TRUSTLINE_FLAGS;
exports.MASK_TRUSTLINE_FLAGS_V13 = MASK_TRUSTLINE_FLAGS_V13;
exports.MASK_TRUSTLINE_FLAGS_V17 = MASK_TRUSTLINE_FLAGS_V17;
exports.MAX_OPS_PER_TX = MAX_OPS_PER_TX;
exports.MAX_SIGNERS = MAX_SIGNERS;
exports.SCSYMBOL_LIMIT = SCSYMBOL_LIMIT;
exports.SC_SPEC_DOC_LIMIT = SC_SPEC_DOC_LIMIT;
exports.TX_ADVERT_VECTOR_MAX_SIZE = TX_ADVERT_VECTOR_MAX_SIZE;
exports.TX_DEMAND_VECTOR_MAX_SIZE = TX_DEMAND_VECTOR_MAX_SIZE;
//# sourceMappingURL=constants.js.map
